export const ONLY_AUTORIZED = true;
export const DEFAULT_LOCALE = 'ru_RU';
export const DEFAULT_LOCALE_SHORT = 'ru';
// export const DEFAULT_LOCALE_SHORT = 'en';
export const DASHBOARD_PAGE = '/dashboard/';
export const HIDE_SYSTEM_ROUTE = true;

const defaultDomainName = process.env.NODE_ENV === 'production' && window.APP_DOMAIN_NAME ? window.APP_DOMAIN_NAME : (process.env.REACT_APP_DOMAIN_NAME || '0.0.0.0');
const defaultPort = process.env.NODE_ENV === 'production' && window.APP_DOMAIN_PORT ? window.APP_DOMAIN_PORT : (process.env.REACT_APP_DOMAIN_PORT || 8080);
const defaultWSPort = process.env.NODE_ENV === 'production' && window.APP_DOMAIN_WS_PORT ? window.APP_DOMAIN_WS_PORT : (process.env.REACT_APP_DOMAIN_WS_PORT || 8080);
const defaultProtocol = process.env.NODE_ENV === 'production' && window.APP_DOMAIN_PROTOCOL ? window.APP_DOMAIN_PROTOCOL : (process.env.REACT_APP_DOMAIN_PROTOCOL || 'http');
const entryPoint = process.env.NODE_ENV === 'production' && window.APP_ENTRY_POINT ? window.APP_ENTRY_POINT : (process.env.REACT_APP_ENTRY_POINT || '');
const entryPointV2 = process.env.NODE_ENV === 'production' && window.APP_ENTRY_POINT_V2 ? window.APP_ENTRY_POINT_V2 : (process.env.REACT_APP_ENTRY_POINT_V2 || '');
const frontUrl = process.env.NODE_ENV === 'production' && window.APP_FRONT_URL ? window.APP_FRONT_URL : (process.env.REACT_APP_FRONT_URL || '');
const defaultUrl = `${defaultProtocol}://${defaultDomainName}`;
const buildVersion = process.env.NODE_ENV === 'production' && window.APP_BUILD_VERSION ? window.APP_BUILD_VERSION : (process.env.REACT_APP_BUILD_VERSION || '1.0.0.0.0');

export const BUILD_VERSION = buildVersion;
export const WS_URL = `ws://${defaultDomainName}:${defaultWSPort}`;
export const BACKEND_URL = defaultUrl + entryPoint;
export const BACKEND_URL_V2 = defaultUrl + entryPointV2;
export const FRONT_URL = frontUrl;
export const CLOAK_CALLBACK = process.env.REACT_APP_CLOAK_CALLBACK || '';
export const ITEMS_OF_PAGE = [{ value: 5, name: 5 }, { value: 10, name: 10 }, { value: 25, name: 25 }, { value: 50, name: 50 }];
// export const DEFAULT_ITEMS_OF_PAGE = 25;
// export const DEFAULT_ITEMS_OF_PAGE = 10;
export const DEFAULT_ITEMS_OF_PAGE = 10;

export const LOADING_DELAY = 500;

export const DEFAULT_DATE_RANGE_SUBTRACT_COUNT = 1;
export const DEFAULT_DATE_RANGE_SUBTRACT_TYPE = 'month';
// size in byte
export const MAX_UPLOAD_FILE_SIZE = 100 * 1024 * 1024;
export const MAX_UPLOAD_FILE_COUNT = 20;
export const CUSTOMER = process.env.REACT_APP_CUSTOMER || '';
export const CUSTOMER_CITY = process.env.REACT_APP_CUSTOMER_CITY || '';
export const CUSTOMER_PHONE = process.env.REACT_APP_CUSTOMER_PHONE || '';
export const CUSTOMER_EMAIL = process.env.REACT_APP_CUSTOMER_EMAIL || '';
export const SUPPORT_PHONE = process.env.REACT_APP_SUPPORT_PHONE || '';
export const SUPPORT_MAIL = process.env.REACT_APP_SUPPORT_MAIL || '';
export const KEYCLOAK_URL = process.env.REACT_APP_KEYCLOAK_URL || '';
export const KEYCLOAK_REALM = process.env.REACT_APP_KEYCLOAK_REALM || '';
export const KEYCLOAK_CLIENT_ID = process.env.REACT_APP_KEYCLOAK_CLIENT_ID || '';

export const DIRECTION = {
  ASC: '+',
  DESC: '-',
};

export const POPUP_LIST_NAME = {
  VISIT_DETAIL: 'VISIT_DETAIL',
  WAY_BILL_DETAIL: 'WAY_BILL_DETAIL',
  CARRIER_DETAIL: 'CARRIER_DETAIL',
  TRANSPORT_DETAIL: 'TRANSPORT_DETAIL',
  VIOLATION_DETAIL: 'VIOLATION_DETAIL',
  ORDER_SERVICE_DETAIL: 'ORDER_SERVICE_DETAIL',
  VEHICLE_REGISTRY_POP_UP: 'VEHICLE_REGISTRY_POP_UP',
  DRIVER_POP_UP: 'DRIVER_POP_UP',
  VEHICLE_REGISTRY_STATUS_HISTORY_POP_UP: 'VEHICLE_REGISTRY_STATUS_HISTORY_POP_UP',
  VIOLATION_CONTROL_WORK_DETAIL: 'VIOLATION_CONTROL_WORK_DETAIL',
  INFORMATION_DETAIL: 'INFORMATION_DETAIL',
  REPRESENTATIVE_DETAIL: 'REPRESENTATIVE_DETAIL',
};

export const STATUS_NAMES = {
  SUCCESS: 'success',
  CHECKING: 'checking',
  SUSPENDED: 'suspended',
  RETURN: 'return',
  DENIED: 'denied',
  NEW: 'new',
  WITHDRAWN: 'withdrawn',
  ARCHIVE: 'archive',
  ANNULMENT: 'annulment',
  SIGN_PENDING: 'signPending',
  SIGNED: 'signed',
  SIGN_FAILED: 'signFailed',
  SENT_MAIS_EGU: 'sentMaisEgu',
  SEND_FAILED_MAIS_EGU: 'sendFailedMaisEgu',
  DRAFT: 'draft',
  WITHDRAWN_2: 'withdrawn_2',
};

export const CHECK_TYPES_TYPE_NAMES = {
  OSAGO: 'osago',
  EGRUL: 'egrul',
  FOREIGNER_TEMPORARY_REGISTRATION: 'foreigner_temporary_registration',
  FOREIGNER_RESIDENT_REGISTRATION: 'foreigner_resident_registration',
  RESIDENT_REGISTRATION_VALIDATION_CHECK: 'resident_registration_validation_check',
  TEMPORARY_REGISTRATION_VALIDATION_CHECK: 'temporary_registration_validation_check',
  IDENTIFIER_VALIDATION_CHECK: 'identifier_validation_check',
  TRANSPORT_REGISTRATION: 'transport_registration',
  CARRIER_INSURANCE: 'carrier_insurance',
  TEMPORARY_REGISTRATION: 'temporary_registration',
  DRIVER_LICENSE: 'driver_license',
  RESIDENCE_CARD: 'residence_card',
  EGRIP: 'egrip',
  RESIDENT_REGISTRATION: 'resident_registration',
};

export const CHECK_TYPES_TYPE_LIST = [
  { value: CHECK_TYPES_TYPE_NAMES.OSAGO, nameId: 'check.types.osago' },
  { value: CHECK_TYPES_TYPE_NAMES.EGRUL, nameId: 'check.types.egrul' },
  { value: CHECK_TYPES_TYPE_NAMES.FOREIGNER_RESIDENT_REGISTRATION, nameId: 'check.types.foreigner_resident_registration' },
  { value: CHECK_TYPES_TYPE_NAMES.RESIDENT_REGISTRATION_VALIDATION_CHECK, nameId: 'check.types.resident_registration_validation_check' },
  { value: CHECK_TYPES_TYPE_NAMES.TEMPORARY_REGISTRATION_VALIDATION_CHECK, nameId: 'check.types.temporary_registration_validation_check' },
  { value: CHECK_TYPES_TYPE_NAMES.IDENTIFIER_VALIDATION_CHECK, nameId: 'check.types.identifier_validation_check' },
  { value: CHECK_TYPES_TYPE_NAMES.TRANSPORT_REGISTRATION, nameId: 'check.types.transport_registration' },
  { value: CHECK_TYPES_TYPE_NAMES.CARRIER_INSURANCE, nameId: 'check.types.carrier_insurance' },
  { value: CHECK_TYPES_TYPE_NAMES.TEMPORARY_REGISTRATION, nameId: 'check.types.temporary_registration' },
  { value: CHECK_TYPES_TYPE_NAMES.DRIVER_LICENSE, nameId: 'check.types.driver_license' },
  { value: CHECK_TYPES_TYPE_NAMES.RESIDENCE_CARD, nameId: 'check.types.residence_card' },
  { value: CHECK_TYPES_TYPE_NAMES.EGRIP, nameId: 'check.types.egrip' },
  { value: CHECK_TYPES_TYPE_NAMES.RESIDENT_REGISTRATION, nameId: 'check.types.resident_registration' },
];

export const APPLICATION_STATUS = {
  DRAFT: 0,
  NEW: 1,
  CHECKING: 2,
  SUSPENDED: 3,
  RETURN: 4,
  DENIED: 5,
  MATCHING: 6,
  SUCCESS: 7,
  WITHDRAWN: 8,
  UPDATED: 9,
  REVIEW: 10,
  SIGN_PENDING: 20,
  SIGNED: 21,
  SIGN_FAILED: 22,
  SENT_MAIS_EGU: 23,
  SEND_FAILED_MAIS_EGU: 24,
  WITHDRAWN_2: 25,
};

export const APPLICATION_STATUS_NAMES = {
  [APPLICATION_STATUS.NEW]: STATUS_NAMES.NEW,
  [APPLICATION_STATUS.CHECKING]: STATUS_NAMES.CHECKING,
  [APPLICATION_STATUS.SUSPENDED]: STATUS_NAMES.SUSPENDED,
  [APPLICATION_STATUS.RETURN]: STATUS_NAMES.RETURN,
  [APPLICATION_STATUS.DENIED]: STATUS_NAMES.DENIED,
  [APPLICATION_STATUS.MATCHING]: STATUS_NAMES.WITHDRAWN,
  [APPLICATION_STATUS.SUCCESS]: STATUS_NAMES.SUCCESS,
  [APPLICATION_STATUS.WITHDRAWN]: STATUS_NAMES.WITHDRAWN,
  [APPLICATION_STATUS.UPDATED]: STATUS_NAMES.SUSPENDED,
  [APPLICATION_STATUS.REVIEW]: STATUS_NAMES.NEW,
  [APPLICATION_STATUS.SIGN_PENDING]: STATUS_NAMES.SIGN_PENDING,
  [APPLICATION_STATUS.SIGNED]: STATUS_NAMES.SIGNED,
  [APPLICATION_STATUS.SIGN_FAILED]: STATUS_NAMES.SIGN_FAILED,
  [APPLICATION_STATUS.SENT_MAIS_EGU]: STATUS_NAMES.SENT_MAIS_EGU,
  [APPLICATION_STATUS.SEND_FAILED_MAIS_EGU]: STATUS_NAMES.SEND_FAILED_MAIS_EGU,
  [APPLICATION_STATUS.DRAFT]: STATUS_NAMES.DRAFT,
  [APPLICATION_STATUS.WITHDRAWN_2]: STATUS_NAMES.WITHDRAWN_2,
};

export const APPLICATION_STATUS_LIST = [
  { value: APPLICATION_STATUS.NEW, nameId: 'application.status.1' },
  { value: APPLICATION_STATUS.CHECKING, nameId: 'application.status.2' },
  { value: APPLICATION_STATUS.SUSPENDED, nameId: 'application.status.3' },
  { value: APPLICATION_STATUS.RETURN, nameId: 'application.status.4' },
  { value: APPLICATION_STATUS.DENIED, nameId: 'application.status.5' },
  // { value: APPLICATION_STATUS.MATCHING, nameId: 'application.status.6' },
  { value: APPLICATION_STATUS.SUCCESS, nameId: 'application.status.7' },
  { value: APPLICATION_STATUS.WITHDRAWN, nameId: 'application.status.8' },
  { value: APPLICATION_STATUS.UPDATED, nameId: 'application.status.9' },
  { value: APPLICATION_STATUS.REVIEW, nameId: 'application.status.10' },
  { value: APPLICATION_STATUS.DRAFT, nameId: 'application.status.0' },
  { value: APPLICATION_STATUS.SIGN_PENDING, nameId: 'application.status.20' },
  { value: APPLICATION_STATUS.SIGNED, nameId: 'application.status.21' },
  { value: APPLICATION_STATUS.SIGN_FAILED, nameId: 'application.status.22' },
  { value: APPLICATION_STATUS.SENT_MAIS_EGU, nameId: 'application.status.23' },
  { value: APPLICATION_STATUS.SEND_FAILED_MAIS_EGU, nameId: 'application.status.24' },
  { value: APPLICATION_STATUS.WITHDRAWN_2, nameId: 'application.status.25' },
];

export const REFERENCE_ARGUMENT_TYPE = [
  { value: 1, nameId: 'reference.argument.type.1' },
  { value: 2, nameId: 'reference.argument.type.2' },
];

export const REGISTRY_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
  ANNULMENT: 3,
  RESUME: 4,
};

export const SZLT_STATUS_NAMES = {
  [REGISTRY_STATUS.ACTIVE]: STATUS_NAMES.SUCCESS,
  [REGISTRY_STATUS.INACTIVE]: STATUS_NAMES.SUSPENDED,
  [REGISTRY_STATUS.ANNULMENT]: STATUS_NAMES.ANNULMENT,
  [REGISTRY_STATUS.RESUME]: STATUS_NAMES.NEW,
};

export const DOCUMENT_STATUS = {
  PENDING: 1,
  CREATED: 2,
  SIGNED: 3,
  FAILED: 4,
};

export const DOCUMENT_IS_ACTUAL = {
  ACTUAL: true,
  NOT_ACTUAL: false,
};

export const CARRIER_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
  ANNULMENT: 3,
  RESUME: 4,
};

export const VEHICLES_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
  ANNULMENT: 3,
  RESUME: 4,
};

export const CHECK_STATUS = {
  PENDING: 1,
  SUCCESS: 2,
  FAILED: 3,
  ERROR: 4,
};

export const CHECK_TYPES_STATUS = {
  ACTIVE: 1,
  ARCHIVE: 2,
};

export const CHECK_TYPE_APPLY_TO_REGISTRIES = {
  CARRIER: 1,
  VEHICLE: 2,
  SZLT: 3,
};

export const REPORT_STATUS = {
  AWAIT: 1,
  PROCESS: 2,
  END: 3,
  ERROR: 4,
};

export const REPORT_TEMPLATE_STATUS = {
  ACTIVE: 1,
  ARCHIVE: 2,
};

export const NOTIFICATION_TEMPLATE_STATUS = {
  ACTIVE: 1,
  ARCHIVE: 2,
};

export const NOTIFICATION_STATUS_MARK = {
  READ: 0,
  UNREAD: 1,
};

export const MAIS_EGU_TYPE_STATUS = {
  ACTIVE: 1,
  ARCHIVE: 2,
};

export const MAIS_EGU_LOG_STATUS = {
  PENDING: 1,
  IN_PROGRESS: 2,
  SENT: 3,
  COMPLETED: 4,
  FAILED: 5,
};

export const FGIS_TAXI_TYPE = {
  CREATE_CARRIER_REQUEST: 'createCarrierRequest',
  CREATE_CARDATA_REQUEST: 'createCarDataRequest',
  CREATE_ORDER_REQUEST: 'createOrderRequest',
};

export const CARRIER_STATUS_NAMES = {
  [CARRIER_STATUS.ACTIVE]: STATUS_NAMES.SUCCESS,
  [CARRIER_STATUS.INACTIVE]: STATUS_NAMES.SUSPENDED,
  [CARRIER_STATUS.ANNULMENT]: STATUS_NAMES.ANNULMENT,
  [CARRIER_STATUS.RESUME]: STATUS_NAMES.NEW,
};

export const VEHICLES_STATUS_NAMES = {
  [VEHICLES_STATUS.ACTIVE]: STATUS_NAMES.SUCCESS,
  [VEHICLES_STATUS.INACTIVE]: STATUS_NAMES.SUSPENDED,
  [VEHICLES_STATUS.ANNULMENT]: STATUS_NAMES.ANNULMENT,
  [VEHICLES_STATUS.RESUME]: STATUS_NAMES.NEW,
};

export const DOCUMENT_STATUS_NAMES = {
  [DOCUMENT_STATUS.PENDING]: STATUS_NAMES.ARCHIVE,
  [DOCUMENT_STATUS.CREATED]: STATUS_NAMES.CHECKING,
  [DOCUMENT_STATUS.SIGNED]: STATUS_NAMES.SUCCESS,
  [DOCUMENT_STATUS.FAILED]: STATUS_NAMES.ANNULMENT,
};

export const MAIS_EGU_TYPE_STATUS_NAMES = {
  [MAIS_EGU_TYPE_STATUS.ACTIVE]: STATUS_NAMES.SUCCESS,
  [MAIS_EGU_TYPE_STATUS.ARCHIVE]: STATUS_NAMES.CHECKING,
};

export const MAIS_EGU_LOG_STATUS_NAMES = {
  [MAIS_EGU_LOG_STATUS.PENDING]: STATUS_NAMES.NEW,
  [MAIS_EGU_LOG_STATUS.IN_PROGRESS]: STATUS_NAMES.CHECKING,
  [MAIS_EGU_LOG_STATUS.SENT]: STATUS_NAMES.SUSPENDED,
  [MAIS_EGU_LOG_STATUS.COMPLETED]: STATUS_NAMES.SUCCESS,
  [MAIS_EGU_LOG_STATUS.FAILED]: STATUS_NAMES.ANNULMENT,
};

export const FGIS_TAXI_TYPE_NAMES = {
  [FGIS_TAXI_TYPE.CREATE_CARRIER_REQUEST]: STATUS_NAMES.CHECKING,
  [FGIS_TAXI_TYPE.CREATE_CARDATA_REQUEST]: STATUS_NAMES.CHECKING,
  [FGIS_TAXI_TYPE.CREATE_ORDER_REQUEST]: STATUS_NAMES.CHECKING,
};

export const CHECK_STATUS_NAMES = {
  [CHECK_STATUS.SUCCESS]: STATUS_NAMES.SUCCESS,
  [CHECK_STATUS.PENDING]: STATUS_NAMES.ARCHIVE,
  [CHECK_STATUS.ERROR]: STATUS_NAMES.SUSPENDED,
  [CHECK_STATUS.FAILED]: STATUS_NAMES.DENIED,
};

export const REPORT_STATUS_NAMES = {
  [REPORT_STATUS.AWAIT]: STATUS_NAMES.ARCHIVE,
  [REPORT_STATUS.PROCESS]: STATUS_NAMES.CHECKING,
  [REPORT_STATUS.END]: STATUS_NAMES.SUCCESS,
  [REPORT_STATUS.ERROR]: STATUS_NAMES.DENIED,
};

export const REPORT_TEMPLATE_STATUS_NAMES = {
  [REPORT_TEMPLATE_STATUS.ACTIVE]: STATUS_NAMES.SUCCESS,
  [REPORT_TEMPLATE_STATUS.ARCHIVE]: STATUS_NAMES.ARCHIVE,
};

export const CHECK_TYPE_STATUS_NAMES = {
  [CHECK_TYPES_STATUS.ACTIVE]: STATUS_NAMES.SUCCESS,
  [CHECK_TYPES_STATUS.ARCHIVE]: STATUS_NAMES.ARCHIVE,
};

export const REGISTRY_EXPORT_NAMES = {
  0: STATUS_NAMES.SUCCESS,
};

export const NOTIFICATION_TEMPLATE_STATUS_NAMES = {
  [NOTIFICATION_TEMPLATE_STATUS.ACTIVE]: STATUS_NAMES.SUCCESS,
  [NOTIFICATION_TEMPLATE_STATUS.ARCHIVE]: STATUS_NAMES.ARCHIVE,
};

export const NOTIFICATION_TEMPLATE_STATUS_LIST = [
  { value: NOTIFICATION_TEMPLATE_STATUS.ACTIVE, nameId: 'notification.template.status.1' },
  { value: NOTIFICATION_TEMPLATE_STATUS.ARCHIVE, nameId: 'notification.template.status.2' },
];

export const NOTIFICATION_STATUS_MARK_LIST = [
  { value: NOTIFICATION_STATUS_MARK.READ, nameId: 'notification.mark.status.1' },
  { value: NOTIFICATION_STATUS_MARK.UNREAD, nameId: 'notification.mark.status.2' },
];

export const CHECK_TYPE_STATUS_LIST = [
  { value: CHECK_TYPES_STATUS.ACTIVE, nameId: 'check.type.status.1' },
  { value: CHECK_TYPES_STATUS.ARCHIVE, nameId: 'check.type.status.2' },
];

export const CHECK_TYPE_APPLY_TO_REGISTRIES_LIST = [
  { value: CHECK_TYPE_APPLY_TO_REGISTRIES.CARRIER, nameId: 'check.types.apply_to_registries.1' },
  { value: CHECK_TYPE_APPLY_TO_REGISTRIES.VEHICLE, nameId: 'check.types.apply_to_registries.2' },
  { value: CHECK_TYPE_APPLY_TO_REGISTRIES.SZLT, nameId: 'check.types.apply_to_registries.3' },
];

export const CHECK_STATUS_LIST = [
  { value: CHECK_STATUS.PENDING, nameId: 'check.status.1' },
  { value: CHECK_STATUS.SUCCESS, nameId: 'check.status.2' },
  { value: CHECK_STATUS.FAILED, nameId: 'check.status.3' },
  { value: CHECK_STATUS.ERROR, nameId: 'check.status.4' },
];

export const MAIS_EGU_TYPE_STATUS_LIST = [
  { value: MAIS_EGU_TYPE_STATUS.ACTIVE, nameId: 'mais.egu.type.status.1' },
  { value: MAIS_EGU_TYPE_STATUS.ARCHIVE, nameId: 'mais.egu.type.status.2' },
];

export const USER_TYPE = {
  LEGAL: 0,
  PRIVATE_PERSON: 1,
  INDIVIDUAL_ENTREPRENEUR: 2,
  PRIVATE_PERSON_OLD: 3,
};

export const DOCUMENT_STATUS_LIST = [
  { value: DOCUMENT_STATUS.PENDING, nameId: 'document.status.1' },
  { value: DOCUMENT_STATUS.CREATED, nameId: 'document.status.2' },
  { value: DOCUMENT_STATUS.SIGNED, nameId: 'document.status.3' },
  { value: DOCUMENT_STATUS.FAILED, nameId: 'document.status.4' },
];

export const DOCUMENT_IS_ACTUAL_LIST = [
  { value: DOCUMENT_IS_ACTUAL.ACTUAL, nameId: 'document.is_actual.actual' },
  { value: DOCUMENT_IS_ACTUAL.NOT_ACTUAL, nameId: 'document.is_actual.not_actual' },
];

export const USER_TYPE_LIST = [
  { value: USER_TYPE.PRIVATE_PERSON, nameId: 'user.type.1' },
  { value: USER_TYPE.LEGAL, nameId: 'user.type.0' },
  { value: USER_TYPE.INDIVIDUAL_ENTREPRENEUR, nameId: 'user.type.2' },
  { value: USER_TYPE.PRIVATE_PERSON_OLD, nameId: 'user.type.3' },
];

export const USER_TYPE_SHORT_NAME_LIST = [
  { value: USER_TYPE.PRIVATE_PERSON, nameId: 'user.type.short.1' },
  { value: USER_TYPE.LEGAL, nameId: 'user.type.short.0' },
  { value: USER_TYPE.INDIVIDUAL_ENTREPRENEUR, nameId: 'user.type.short.2' },
];

export const REGISTRATION_TYPE = {
  PERMANENT: 0,
  TEMPORARY: 1,
  NO_REGISTRATION: 2,
};

export const REGISTRATION_TYPE_LIST = [
  { value: REGISTRATION_TYPE.PERMANENT, nameId: 'registration.type.0' },
  { value: REGISTRATION_TYPE.TEMPORARY, nameId: 'registration.type.1' },
  { value: REGISTRATION_TYPE.NO_REGISTRATION, nameId: 'registration.type.2' },
];

export const CITIZENSHIP_TYPE = {
  RU: 0,
  FOREIGN_CITIZEN: 1,
  STATELESS_PERSON: 2,
};

export const CITIZENSHIP_TYPE_LIST = [
  { value: CITIZENSHIP_TYPE.RU, nameId: 'citizenship.type.0' },
  { value: CITIZENSHIP_TYPE.FOREIGN_CITIZEN, nameId: 'citizenship.type.1' },
  { value: CITIZENSHIP_TYPE.STATELESS_PERSON, nameId: 'citizenship.type.2' },
];

export const GENDER_TYPE = {
  MALE: 0,
  FEMALE: 1,
};

export const GENDER_OPTIONS = [
  { value: GENDER_TYPE.MALE, nameId: 'gender.0' },
  { value: GENDER_TYPE.FEMALE, nameId: 'gender.1' },
];

export const IDENTITY_TYPE = {
  PASSPORT_RF: 0,
  MILITARY_ID_CARD: 1,
  SAILOR_PASSPORT: 2,
  USSR_PASSPORT: 3,
  BIRTH_CERTIFICATE: 4,
  TEMPORARY_ID_CARD: 5,
  TRAVEL_PASSPORT_RF: 6,
  FOREIGN_BIRTH_CERTIFICATE: 7,
  FOREIGN_PASSPORT: 8,
  TEMPORARY_RESIDENCE_PERMIT: 9,
  RESIDENCE_CARD: 10,
  REFUGEE_CERTIFICATE: 11,
  REFUGEE_ID_CARD: 12,
};

export const IDENTITY_TYPE_LIST = [
  { value: IDENTITY_TYPE.PASSPORT_RF, nameId: 'identity.type.0' },
  { value: IDENTITY_TYPE.MILITARY_ID_CARD, nameId: 'identity.type.1' },
  { value: IDENTITY_TYPE.SAILOR_PASSPORT, nameId: 'identity.type.2' },
  { value: IDENTITY_TYPE.USSR_PASSPORT, nameId: 'identity.type.3' },
  { value: IDENTITY_TYPE.BIRTH_CERTIFICATE, nameId: 'identity.type.4' },
  { value: IDENTITY_TYPE.TEMPORARY_ID_CARD, nameId: 'identity.type.5' },
  { value: IDENTITY_TYPE.TRAVEL_PASSPORT_RF, nameId: 'identity.type.6' },
  { value: IDENTITY_TYPE.FOREIGN_BIRTH_CERTIFICATE, nameId: 'identity.type.7' },
  { value: IDENTITY_TYPE.FOREIGN_PASSPORT, nameId: 'identity.type.8' },
  { value: IDENTITY_TYPE.TEMPORARY_RESIDENCE_PERMIT, nameId: 'identity.type.9' },
  { value: IDENTITY_TYPE.RESIDENCE_CARD, nameId: 'identity.type.10' },
  { value: IDENTITY_TYPE.REFUGEE_CERTIFICATE, nameId: 'identity.type.11' },
  { value: IDENTITY_TYPE.REFUGEE_ID_CARD, nameId: 'identity.type.12' },
];

export const OWNERSHIP_TYPE = {
  OWNER: 1,
  LEASE: 2,
  RENT: 3,
  POWER_OF_ATTORNEY: 4,
};

export const ECOLOGY_CLASS_TYPE = {
  0: '00',
  1: '01',
  2: '02',
  3: '03',
  4: '04',
  5: '05',
  6: '06',
  7: '77',
};

export const OWNERSHIP_TYPE_LIST = [
  { value: OWNERSHIP_TYPE.OWNER, nameId: 'ownership.type.1' },
  { value: OWNERSHIP_TYPE.LEASE, nameId: 'ownership.type.2' },
  { value: OWNERSHIP_TYPE.RENT, nameId: 'ownership.type.3' },
  { value: OWNERSHIP_TYPE.POWER_OF_ATTORNEY, nameId: 'ownership.type.4' },
];

export const ECOLOGY_CLASS_TYPE_LIST = [
  { value: ECOLOGY_CLASS_TYPE[0], nameId: 'ecology-class.00' },
  { value: ECOLOGY_CLASS_TYPE[1], nameId: 'ecology-class.01' },
  { value: ECOLOGY_CLASS_TYPE[2], nameId: 'ecology-class.02' },
  { value: ECOLOGY_CLASS_TYPE[3], nameId: 'ecology-class.03' },
  { value: ECOLOGY_CLASS_TYPE[4], nameId: 'ecology-class.04' },
  { value: ECOLOGY_CLASS_TYPE[5], nameId: 'ecology-class.05' },
  { value: ECOLOGY_CLASS_TYPE[6], nameId: 'ecology-class.06' },
  { value: ECOLOGY_CLASS_TYPE[7], nameId: 'ecology-class.77' },
];

export const PROCEDURE_TYPE = {
  PROCEDURE_1227_1: '1227.1',
  PROCEDURE_1227_2: '1227.2',
  PROCEDURE_1227_3: '1227.3',
  PROCEDURE_1227_4: '1227.4',
  PROCEDURE_1227_5: '1227.5',
  PROCEDURE_1227_6: '1227.6',
  PROCEDURE_1227_7: '1227.7',
  PROCEDURE_1227_8: '1227.8',
  PROCEDURE_1227_9: '1227.9',
  PROCEDURE_kt_exlt: 'kt-exlt',
  PROCEDURE_1228_1: '1228.1',
  PROCEDURE_1228_2: '1228.2',
  PROCEDURE_1228_3: '1228.3',
  PROCEDURE_1228_4: '1228.4',
};

export const PROCEDURE_TYPE_LIST = [
  { value: PROCEDURE_TYPE.PROCEDURE_1227_1, nameId: 'procedure.type.1227.1' },
  { value: PROCEDURE_TYPE.PROCEDURE_1227_2, nameId: 'procedure.type.1227.2' },
  { value: PROCEDURE_TYPE.PROCEDURE_1227_3, nameId: 'procedure.type.1227.3' },
  { value: PROCEDURE_TYPE.PROCEDURE_1227_4, nameId: 'procedure.type.1227.4' },
  { value: PROCEDURE_TYPE.PROCEDURE_1227_5, nameId: 'procedure.type.1227.5' },
  { value: PROCEDURE_TYPE.PROCEDURE_1227_6, nameId: 'procedure.type.1227.6' },
  { value: PROCEDURE_TYPE.PROCEDURE_1227_7, nameId: 'procedure.type.1227.7' },
  { value: PROCEDURE_TYPE.PROCEDURE_1227_8, nameId: 'procedure.type.1227.8' },
  { value: PROCEDURE_TYPE.PROCEDURE_1227_9, nameId: 'procedure.type.1227.9' },
  { value: PROCEDURE_TYPE.PROCEDURE_kt_exlt, nameId: 'procedure.type.kt-exlt' },
  { value: PROCEDURE_TYPE.PROCEDURE_1228_1, nameId: 'procedure.type.1228.1' },
  { value: PROCEDURE_TYPE.PROCEDURE_1228_2, nameId: 'procedure.type.1228.2' },
  { value: PROCEDURE_TYPE.PROCEDURE_1228_3, nameId: 'procedure.type.1228.3' },
  { value: PROCEDURE_TYPE.PROCEDURE_1228_4, nameId: 'procedure.type.1228.4' },
];

export const PROCEDURE_VEHICLE_TYPES = [
  PROCEDURE_TYPE.PROCEDURE_1227_6,
  PROCEDURE_TYPE.PROCEDURE_1227_7,
  PROCEDURE_TYPE.PROCEDURE_1227_8,
  PROCEDURE_TYPE.PROCEDURE_1227_9,
  PROCEDURE_TYPE.PROCEDURE_kt_exlt,
];

export const PROCEDURE_SZLT_TYPES = [
  PROCEDURE_TYPE.PROCEDURE_1228_1,
  PROCEDURE_TYPE.PROCEDURE_1228_2,
  PROCEDURE_TYPE.PROCEDURE_1228_3,
  PROCEDURE_TYPE.PROCEDURE_1228_4,
];

export const PROCEDURE_CARRIER_TYPES = [
  PROCEDURE_TYPE.PROCEDURE_1227_1,
  PROCEDURE_TYPE.PROCEDURE_1227_2,
  PROCEDURE_TYPE.PROCEDURE_1227_3,
  PROCEDURE_TYPE.PROCEDURE_1227_4,
  PROCEDURE_TYPE.PROCEDURE_1227_5,
];

export const APPLY_METHOD_TYPE = {
  PORTAL: 1,
  MFC: 2,
  COMMITTEE: 3,
  POST: 4,
};

export const APPLY_METHOD_TYPE_LIST = [
  { value: APPLY_METHOD_TYPE.PORTAL, nameId: 'apply.method.type.1' },
  { value: APPLY_METHOD_TYPE.MFC, nameId: 'apply.method.type.2' },
  { value: APPLY_METHOD_TYPE.COMMITTEE, nameId: 'apply.method.type.3' },
  { value: APPLY_METHOD_TYPE.POST, nameId: 'apply.method.type.4' },
];

export const DOCUMENT_SUBMISSION_TYPE = {
  PA: 1,
  EL: 2,
};

export const DOCUMENT_SUBMISSION_TYPE_LIST = [
  { value: DOCUMENT_SUBMISSION_TYPE.PA, nameId: 'document.submission.type.1' },
  { value: DOCUMENT_SUBMISSION_TYPE.EL, nameId: 'document.submission.type.2' },
];

export const DELIVERY_METHOD_TYPE = {
  MAIS: 1,
  MFC: 2,
  RUSSIAN_POST: 3,
  NO_SEND: 4,
};

export const NOTIFICATION_METHOD_TYPE = {
  EMAIL: 1,
  SMS: 2,
  NOTIFICATION: 3,
  SOCIAL: 4,
};

export const DELIVERY_METHOD_EXTRACTS_TYPE_LIST = [
  { value: DELIVERY_METHOD_TYPE.MAIS, nameId: 'delivery.method.type.1' },
  { value: DELIVERY_METHOD_TYPE.MFC, nameId: 'delivery.method.type.2' },
  { value: DELIVERY_METHOD_TYPE.RUSSIAN_POST, nameId: 'delivery.method.type.3' },
  { value: DELIVERY_METHOD_TYPE.NO_SEND, nameId: 'delivery.method.type.4' },
];

export const DELIVERY_METHOD_TYPE_LIST = [
  { value: DELIVERY_METHOD_TYPE.MAIS, nameId: 'delivery.method.type.1' },
  { value: DELIVERY_METHOD_TYPE.MFC, nameId: 'delivery.method.type.2' },
  { value: DELIVERY_METHOD_TYPE.RUSSIAN_POST, nameId: 'delivery.method.type.3' },
];

export const NOTIFICATION_METHOD_TYPE_LIST = [
  { value: NOTIFICATION_METHOD_TYPE.EMAIL, nameId: 'notification.method.type.1' },
  { value: NOTIFICATION_METHOD_TYPE.SMS, nameId: 'notification.method.type.2' },
  { value: NOTIFICATION_METHOD_TYPE.NOTIFICATION, nameId: 'notification.method.type.3' },
  { value: NOTIFICATION_METHOD_TYPE.SOCIAL, nameId: 'notification.method.type.4' },
];

export const VIEWED_FILE_MIME_TYPES = [
  'image/jpeg',
];

export const DOCUMENT_TYPE = {
  REPORT: 0,
};

export const DOCUMENT_TYPE_LIST = [
  { value: DOCUMENT_TYPE.REPORT, nameId: 'document.type.0' },
];

export const EXPORT_TYPE = {
  EMAIL: 0,
  FTP: 1,
};

export const EXPORT_TYPE_LIST = [
  { value: EXPORT_TYPE.EMAIL, nameId: 'export.type.0' },
  { value: EXPORT_TYPE.FTP, nameId: 'export.type.1' },
];

export const EXPORT_PERIOD_OPTIONS = [
  { value: 0, nameId: 'export.period.0' },
  { value: 1, nameId: 'export.period.1' },
  { value: 2, nameId: 'export.period.1' },
];

export const SUBJECT_TYPE = {
  APPLICATION: 'application',
  APPLICATION_APPLICANT: 'application_applicant',
  APPLICATION_CARRIER: 'application_carrier',
  APPLICATION_INSURANCE: 'application_insurance',
  APPLICATION_ORDER_SERVICE: 'application_order_service',
  APPLICATION_OSGOP_INSURANCE: 'application_osgop_insurance',
  APPLICATION_REPRESENTATIVE: 'application_representative',
  APPLICATION_VEHICLE: 'application_vehicle',
  APPLICANT: 'dict.applicant',
  CARRIER: 'carrier',
  CARRIER_ORDER_SERVICE: 'carrier_order_service',
  ORDER_SERVICE: 'order_service',
  VEHICLE: 'vehicle',
  DOCUMENT: 'document',
  REJECTION_REASONS: 'rejection_reason',
  NOTIFICATION_TEMPLATES: 'notification_template',
  ROLLBACK_PLAN: 'rollback_plan',
  WAYBILL: 'dict.waybill',
};

export const SUBJECT_TYPE_LIST = [
  { value: SUBJECT_TYPE.APPLICATION, nameId: 'subject.type.full.application' },
  { value: SUBJECT_TYPE.APPLICATION_APPLICANT, nameId: 'subject.type.full.application_applicant' },
  { value: SUBJECT_TYPE.APPLICATION_CARRIER, nameId: 'subject.type.full.application_carrier' },
  { value: SUBJECT_TYPE.APPLICATION_INSURANCE, nameId: 'subject.type.full.application_insurance' },
  { value: SUBJECT_TYPE.APPLICATION_ORDER_SERVICE, nameId: 'subject.type.full.application_order_service' },
  { value: SUBJECT_TYPE.APPLICATION_OSGOP_INSURANCE, nameId: 'subject.type.full.application_osgop_insurance' },
  { value: SUBJECT_TYPE.APPLICATION_REPRESENTATIVE, nameId: 'subject.type.full.application_representative' },
  { value: SUBJECT_TYPE.APPLICATION_VEHICLE, nameId: 'subject.type.full.application_vehicle' },
  { value: SUBJECT_TYPE.CARRIER, nameId: 'subject.type.full.carrier' },
  { value: SUBJECT_TYPE.CARRIER_ORDER_SERVICE, nameId: 'subject.type.full.carrier_order_service' },
  { value: SUBJECT_TYPE.ORDER_SERVICE, nameId: 'subject.type.full.order_service' },
  { value: SUBJECT_TYPE.VEHICLE, nameId: 'subject.type.full.vehicle' },
  { value: SUBJECT_TYPE.DOCUMENT, nameId: 'subject.type.full.document' },
];

export const SUBJECT_TYPE_ONLY_REGISTRY_LIST = [
  { value: SUBJECT_TYPE.CARRIER, nameId: 'subject.type.full.carrier' },
  { value: SUBJECT_TYPE.VEHICLE, nameId: 'subject.type.full.vehicle' },
  { value: SUBJECT_TYPE.ORDER_SERVICE, nameId: 'subject.type.full.order_service' },
];

export const APPLICATION_SUBJECT_TYPES = [SUBJECT_TYPE.APPLICATION, SUBJECT_TYPE.APPLICATION_APPLICANT, SUBJECT_TYPE.APPLICATION_CARRIER, SUBJECT_TYPE.APPLICATION_INSURANCE, SUBJECT_TYPE.APPLICATION_ORDER_SERVICE, SUBJECT_TYPE.APPLICATION_OSGOP_INSURANCE, SUBJECT_TYPE.APPLICATION_REPRESENTATIVE, SUBJECT_TYPE.APPLICATION_VEHICLE];
export const CARRIER_SUBJECT_TYPES = [SUBJECT_TYPE.CARRIER, SUBJECT_TYPE.CARRIER_ORDER_SERVICE];

export const REGISTRIES_TYPE = {
  CARRIER: 1,
  ORDER_SERVICE: 2,
  VEHICLE: 3,
};

export const REGISTRIES_TYPE_LIST = [
  { value: REGISTRIES_TYPE.CARRIER, nameId: 'subject.type.carrier' },
  { value: REGISTRIES_TYPE.ORDER_SERVICE, nameId: 'subject.type.order_service' },
  { value: REGISTRIES_TYPE.VEHICLE, nameId: 'subject.type.vehicle' },
];

export const REASON_TYPE = {
  APPLICATION_SUSPENDED: 3,
  APPLICATION_RETURNED: 4,
  APPLICATION_DENIED: 5,
  REGISTRY_CANCELED: 6,
  REGISTRY_SUSPENDED: 7,
  REGISTRY_RESUMED: 8,
};
export const REGISTRY_TYPE = {
  CARRIER: 1,
  ORDER_SERVICE: 2,
  VEHICLE: 3,
};

export const REASON_TYPE_LIST = [
  { value: REASON_TYPE.APPLICATION_SUSPENDED, nameId: 'reason.type.3' },
  { value: REASON_TYPE.APPLICATION_DENIED, nameId: 'reason.type.5' },
  { value: REASON_TYPE.APPLICATION_RETURNED, nameId: 'reason.type.4' },
  { value: REASON_TYPE.REGISTRY_SUSPENDED, nameId: 'reason.type.7' },
  { value: REASON_TYPE.REGISTRY_RESUMED, nameId: 'reason.type.8' },
  { value: REASON_TYPE.REGISTRY_CANCELED, nameId: 'reason.type.6' },
];

export const REGISTRIES_STATUS_LIST = [
  { value: CARRIER_STATUS.ACTIVE, nameId: 'carrier.status.1' },
  { value: CARRIER_STATUS.INACTIVE, nameId: 'carrier.status.2' },
  { value: CARRIER_STATUS.ANNULMENT, nameId: 'carrier.status.3' },
  { value: CARRIER_STATUS.RESUME, nameId: 'carrier.status.4' },
];

export const REGISTRIES_VEHICLE_STATUS_LIST = [
  { value: VEHICLES_STATUS.ACTIVE, nameId: 'vehicles.status.1' },
  { value: VEHICLES_STATUS.ANNULMENT, nameId: 'vehicles.status.3' },
];

export const FILE_FORMAT = {
  CSV: 'csv',
  XLS: 'xls',
  XLSX: 'xlsx',
  PDF: 'pdf',
};

export const FILE_FORMAT_LIST = [
  { value: FILE_FORMAT.CSV, nameId: 'file.format.csv' },
  { value: FILE_FORMAT.XLS, nameId: 'file.format.xls' },
  { value: FILE_FORMAT.XLSX, nameId: 'file.format.xlsx' },
];

export const IN_REGISTRY_LIST = [
  { value: 0, nameId: 'in.registry.0' },
  { value: 1, nameId: 'in.registry.1' },
];

export const DICT_VEHICLE_REGISTER_STATUS = {
  NO_AVAILABLE: 1,
  AVAILABLE: 2,
  GO_TO_PASSENGER: 3,
  AWAIT_PASSENGER: 4,
  GO_WITH_PASSENGER: 5,
  NO_DATA: 'undefined',
};

export const DICT_VEHICLE_STATUS_NAMES = {
  [DICT_VEHICLE_REGISTER_STATUS.NO_AVAILABLE]: STATUS_NAMES.DENIED,
  [DICT_VEHICLE_REGISTER_STATUS.AVAILABLE]: STATUS_NAMES.NEW,
  [DICT_VEHICLE_REGISTER_STATUS.GO_TO_PASSENGER]: STATUS_NAMES.WITHDRAWN,
  [DICT_VEHICLE_REGISTER_STATUS.AWAIT_PASSENGER]: STATUS_NAMES.SUSPENDED,
  [DICT_VEHICLE_REGISTER_STATUS.GO_WITH_PASSENGER]: STATUS_NAMES.SUCCESS,
  [DICT_VEHICLE_REGISTER_STATUS.NO_DATA]: STATUS_NAMES.ANNULMENT,
};

export const VEHICLE_STATUS_LIST = [
  { value: DICT_VEHICLE_REGISTER_STATUS.NO_AVAILABLE, nameId: 'vehicle.register.status.1' },
  { value: DICT_VEHICLE_REGISTER_STATUS.AVAILABLE, nameId: 'vehicle.register.status.2' },
  { value: DICT_VEHICLE_REGISTER_STATUS.GO_TO_PASSENGER, nameId: 'vehicle.register.status.3' },
  { value: DICT_VEHICLE_REGISTER_STATUS.AWAIT_PASSENGER, nameId: 'vehicle.register.status.4' },
  { value: DICT_VEHICLE_REGISTER_STATUS.GO_WITH_PASSENGER, nameId: 'vehicle.register.status.5' },
];

export const IN_REQUEST_INF_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
};

export const IN_REQUEST_INF_STATUS_LIST = [
  { value: IN_REQUEST_INF_STATUS.SUCCESS, nameId: 'in_request_inf.status.success' },
  { value: IN_REQUEST_INF_STATUS.ERROR, nameId: 'in_request_inf.status.error' },
];

export const IN_REQUEST_INF_TYPE_ENUM = {
  CARRIER: 'carrier',
  CARRIAGE_CONTRACT: 'carriage_contract',
  DRIVER: 'driver',
  LOCATION: 'location',
  MEDICAL_EXAM: 'medical_exam',
  OSAGO: 'osago',
  OSGOP: 'osgop',
  TARIFF: 'tariff',
  TRIP: 'trip',
  VEHICLE: 'vehicle',
  WAYBILL: 'waybill',
};

export const IN_REQUEST_INF_TYPE_ENUM_LIST = [
  { value: IN_REQUEST_INF_TYPE_ENUM.CARRIER, nameId: 'in_request_inf.type.carrier' },
  { value: IN_REQUEST_INF_TYPE_ENUM.CARRIAGE_CONTRACT, nameId: 'in_request_inf.type.carriage_contract' },
  { value: IN_REQUEST_INF_TYPE_ENUM.DRIVER, nameId: 'in_request_inf.type.driver' },
  { value: IN_REQUEST_INF_TYPE_ENUM.MEDICAL_EXAM, nameId: 'in_request_inf.type.medical_exam' },
  { value: IN_REQUEST_INF_TYPE_ENUM.OSAGO, nameId: 'in_request_inf.type.osago' },
  { value: IN_REQUEST_INF_TYPE_ENUM.OSGOP, nameId: 'in_request_inf.type.osgop' },
  { value: IN_REQUEST_INF_TYPE_ENUM.TARIFF, nameId: 'in_request_inf.type.tariff' },
  { value: IN_REQUEST_INF_TYPE_ENUM.TRIP, nameId: 'in_request_inf.type.trip' },
  { value: IN_REQUEST_INF_TYPE_ENUM.VEHICLE, nameId: 'in_request_inf.type.vehicle' },
  { value: IN_REQUEST_INF_TYPE_ENUM.WAYBILL, nameId: 'in_request_inf.type.waybill' },
  { value: IN_REQUEST_INF_TYPE_ENUM.LOCATION, nameId: 'in_request_inf.type.location' },
];

export const LAST_UPDATE = {
  MINUTE: 1,
  MINUTE_30: 2,
  MORE_30_MINUTE: 3,
  MORE_HOUR: 4,
};

export const LAST_UPDATE_LIST = [
  { value: LAST_UPDATE.MINUTE, nameId: 'last.update.1' },
  { value: LAST_UPDATE.MINUTE_30, nameId: 'last.update.2' },
  { value: LAST_UPDATE.MORE_30_MINUTE, nameId: 'last.update.3' },
  { value: LAST_UPDATE.MORE_HOUR, nameId: 'last.update.4' },
];

export const SPEED = {
  NORMAL: 1,
  WARNING: 2,
  VIOLATION: 3,
};

export const SPEED_LIST = [
  { value: SPEED.NORMAL, nameId: 'speed.1' },
  { value: SPEED.WARNING, nameId: 'speed.2' },
  { value: SPEED.VIOLATION, nameId: 'speed.3' },
];

export const SUBJECT_TYPE_LIST_FILTER = [
  { value: SUBJECT_TYPE.APPLICATION, nameId: 'subject.type.full.application' },
  // { value: SUBJECT_TYPE.APPLICATION_APPLICANT, nameId: 'subject.type.full.application_applicant' },
  // { value: SUBJECT_TYPE.APPLICATION_CARRIER, nameId: 'subject.type.full.application_carrier' },
  // { value: SUBJECT_TYPE.APPLICATION_INSURANCE, nameId: 'subject.type.full.application_insurance' },
  // { value: SUBJECT_TYPE.APPLICATION_ORDER_SERVICE, nameId: 'subject.type.full.application_order_service' },
  // { value: SUBJECT_TYPE.APPLICATION_OSGOP_INSURANCE, nameId: 'subject.type.full.application_osgop_insurance' },
  // { value: SUBJECT_TYPE.APPLICATION_REPRESENTATIVE, nameId: 'subject.type.full.application_representative' },
  // { value: SUBJECT_TYPE.APPLICATION_VEHICLE, nameId: 'subject.type.full.application_vehicle' },
  { value: SUBJECT_TYPE.CARRIER, nameId: 'subject.type.full.carrier' },
  // { value: SUBJECT_TYPE.CARRIER_ORDER_SERVICE, nameId: 'subject.type.full.carrier_order_service' },
  { value: SUBJECT_TYPE.ORDER_SERVICE, nameId: 'subject.type.full.order_service' },
  { value: SUBJECT_TYPE.VEHICLE, nameId: 'subject.type.full.vehicle' },
  { value: SUBJECT_TYPE.DOCUMENT, nameId: 'subject.type.full.document' },
  { value: SUBJECT_TYPE.REJECTION_REASONS, nameId: 'subject.type.full.rejection_reasons' },
  { value: SUBJECT_TYPE.NOTIFICATION_TEMPLATES, nameId: 'subject.type.full.notification_templates' },
];

export const TRAVEL_TIME = {
  ALL: 'all',
  NORMAL: '8-9h',
  OVERTIME: '9h+',
};

export const TRAVEL_TIME_LIST = [
  { value: TRAVEL_TIME.ALL, nameId: 'travel.time.1' },
  { value: TRAVEL_TIME.NORMAL, nameId: 'travel.time.2' },
  { value: TRAVEL_TIME.OVERTIME, nameId: 'travel.time.3' },
];

export const VALIDITY_LICENSES = {
  MONTH: 1,
  WEEK: 2,
  NOW: 3,
};

export const VALIDITY_LICENSES_LIST = [
  { value: VALIDITY_LICENSES.MONTH, nameId: 'validity.licenses.1' },
  { value: VALIDITY_LICENSES.WEEK, nameId: 'validity.licenses.2' },
  { value: VALIDITY_LICENSES.NOW, nameId: 'validity.licenses.3' },
];

export const REGISTRY_PRESENCE = {
  IN_REGISTRY_LT: '1',
  NOT_IN_REGISTRY_LT: '0',
};

export const VEHICLE_REGISTRY_PRESENCE_LIST = [
  { value: REGISTRY_PRESENCE.IN_REGISTRY_LT, nameId: 'vehicle_registry.presence.in_registry_lt' },
  { value: REGISTRY_PRESENCE.NOT_IN_REGISTRY_LT, nameId: 'vehicle_registry.presence.not_in_registry_lt' },
];

export const VIOLATION_STATUS = {
  CANCELED: 'canceled',
  ACTIVE: 'active',
};

export const VIOLATION_STATUS_LIST = [
  { value: VIOLATION_STATUS.CANCELED, nameId: 'violation.status.canceled' },
  { value: VIOLATION_STATUS.ACTIVE, nameId: 'violation.status.active' },
];

export const WORK_REST_VIOLATION_TYPE = {
  DAILY_REST_LESS_THAN_DOUBLE_SHIFT: 'daily_rest_less_than_double_shift',
  DAILY_REST_UNDER_9H: 'daily_rest_under_9h',
  REDUCED_DAILY_REST_EXCEEDED: 'reduced_daily_rest_exceeded',
  INSUFFICIENT_FULL_REST_PER_WEEK: 'insufficient_full_rest_per_week',
  SPECIAL_BREAK_MISSING: 'special_break_missing',
  MEAL_BREAK_MISSING: 'meal_break_missing',
  DAILY_DRIVING_OVER_10H: 'daily_driving_over_10h',
  EXTENDED_DRIVING_EXCEEDED_2_PER_WEEK: 'extended_driving_exceeded_2_per_week',
  WEEKLY_DRIVING_OVER_56H: 'weekly_driving_over_56h',
  BIWEEKLY_DRIVING_OVER_90H: 'biweekly_driving_over_90h',
  WEEKLY_LIMIT_EXCEEDED: 'weekly_limit_exceeded',
  FOUR_WEEK_LIMIT_EXCEEDED: 'four_week_limit_exceeded',
  TWELVE_WEEK_LIMIT_EXCEEDED: 'twelve_week_limit_exceeded',
  SHIFT_OVER_12H: 'shift_over_12h',
  TRIP_BEFORE_SHIFT_START: 'trip_before_shift_start',
  TRIP_AFTER_SHIFT_END: 'trip_after_shift_end',
  TRIP_WITHOUT_WAYBILL: 'trip_without_waybill',
  OVER_6_DAILY_PERIODS: 'over_6_daily_periods',
  WEEKLY_REST_UNDER_24H: 'weekly_rest_under_24h',
  REDUCED_WEEKLY_REST_EXCEEDED: 'reduced_weekly_rest_exceeded',
  UNCOMPENSATED_WEEKLY_REST: 'uncompensated_weekly_rest',
};

export const WORK_REST_VIOLATION_TYPE_LIST = [
  { value: WORK_REST_VIOLATION_TYPE.DAILY_REST_LESS_THAN_DOUBLE_SHIFT, nameId: 'work_rest_violation_type.daily_rest_less_than_double_shift' },
  { value: WORK_REST_VIOLATION_TYPE.DAILY_REST_UNDER_9H, nameId: 'work_rest_violation_type.daily_rest_under_9h' },
  { value: WORK_REST_VIOLATION_TYPE.REDUCED_DAILY_REST_EXCEEDED, nameId: 'work_rest_violation_type.reduced_daily_rest_exceeded' },
  { value: WORK_REST_VIOLATION_TYPE.INSUFFICIENT_FULL_REST_PER_WEEK, nameId: 'work_rest_violation_type.insufficient_full_rest_per_week' },
  { value: WORK_REST_VIOLATION_TYPE.SPECIAL_BREAK_MISSING, nameId: 'work_rest_violation_type.special_break_missing' },
  { value: WORK_REST_VIOLATION_TYPE.MEAL_BREAK_MISSING, nameId: 'work_rest_violation_type.meal_break_missing' },
  { value: WORK_REST_VIOLATION_TYPE.DAILY_DRIVING_OVER_10H, nameId: 'work_rest_violation_type.daily_driving_over_10h' },
  { value: WORK_REST_VIOLATION_TYPE.EXTENDED_DRIVING_EXCEEDED_2_PER_WEEK, nameId: 'work_rest_violation_type.extended_driving_exceeded_2_per_week' },
  { value: WORK_REST_VIOLATION_TYPE.WEEKLY_DRIVING_OVER_56H, nameId: 'work_rest_violation_type.weekly_driving_over_56h' },
  { value: WORK_REST_VIOLATION_TYPE.BIWEEKLY_DRIVING_OVER_90H, nameId: 'work_rest_violation_type.biweekly_driving_over_90h' },
  { value: WORK_REST_VIOLATION_TYPE.WEEKLY_LIMIT_EXCEEDED, nameId: 'work_rest_violation_type.weekly_limit_exceeded' },
  { value: WORK_REST_VIOLATION_TYPE.FOUR_WEEK_LIMIT_EXCEEDED, nameId: 'work_rest_violation_type.four_week_limit_exceeded' },
  { value: WORK_REST_VIOLATION_TYPE.TWELVE_WEEK_LIMIT_EXCEEDED, nameId: 'work_rest_violation_type.twelve_week_limit_exceeded' },
  { value: WORK_REST_VIOLATION_TYPE.SHIFT_OVER_12H, nameId: 'work_rest_violation_type.shift_over_12h' },
  { value: WORK_REST_VIOLATION_TYPE.TRIP_BEFORE_SHIFT_START, nameId: 'work_rest_violation_type.trip_before_shift_start' },
  { value: WORK_REST_VIOLATION_TYPE.TRIP_AFTER_SHIFT_END, nameId: 'work_rest_violation_type.trip_after_shift_end' },
  { value: WORK_REST_VIOLATION_TYPE.TRIP_WITHOUT_WAYBILL, nameId: 'work_rest_violation_type.trip_without_waybill' },
  { value: WORK_REST_VIOLATION_TYPE.OVER_6_DAILY_PERIODS, nameId: 'work_rest_violation_type.over_6_daily_periods' },
  { value: WORK_REST_VIOLATION_TYPE.WEEKLY_REST_UNDER_24H, nameId: 'work_rest_violation_type.weekly_rest_under_24h' },
  { value: WORK_REST_VIOLATION_TYPE.REDUCED_WEEKLY_REST_EXCEEDED, nameId: 'work_rest_violation_type.reduced_weekly_rest_exceeded' },
  { value: WORK_REST_VIOLATION_TYPE.UNCOMPENSATED_WEEKLY_REST, nameId: 'work_rest_violation_type.uncompensated_weekly_rest' },
];

export const DEFAULT_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
  ANNULMENT: 3,
  RESUME: 4,
};

export const DEFAULT_STATUS_LIST = [
  { value: DEFAULT_STATUS.ACTIVE, nameId: 'default.status.1' },
  { value: DEFAULT_STATUS.INACTIVE, nameId: 'default.status.2' },
  { value: DEFAULT_STATUS.ANNULMENT, nameId: 'default.status.3' },
  { value: DEFAULT_STATUS.RESUME, nameId: 'default.status.4' },
];

export const REGION_REGISTRY_RELATION = {
  VEHICLE_ORDER_SERVICE: 'vehicle_order_service_link',
  VEHICLE_CARRIER: 'vehicle_carrier_link',
  CARRIER_SERVICE: 'carrier_order_service_link',
  CARRIER_VEHICLE: 'carrier_vehicle_link',
  ORDER_SERVICE_CARRIER: 'order_service_carrier_link',
};

export const FILE_FORMAT_LIST_NEW = [
  { value: FILE_FORMAT.CSV, nameId: 'file.format.csv' },
  { value: FILE_FORMAT.XLSX, nameId: 'file.format.xlsx' },
];

export const WORK_REST_VIOLATIONS_FILE_FORMAT_LIST = [
  { value: FILE_FORMAT.CSV, nameId: 'file.format.csv' },
  { value: FILE_FORMAT.XLS, nameId: 'file.format.xls' },
  { value: FILE_FORMAT.PDF, nameId: 'file.format.pdf' },
  { value: FILE_FORMAT.XLSX, nameId: 'file.format.xlsx' },
];

export const VEHICLE_REGISTRY_BASIS_TYPE = {
  EXEMPTION_1: 1,
  EXEMPTION_2: 2,
  EXEMPTION_3: 3,
};

export const VEHICLE_REGISTRY_BASIS_LIST = [
  { value: VEHICLE_REGISTRY_BASIS_TYPE.EXEMPTION_1, nameId: 'applicant.exemption.1' },
  { value: VEHICLE_REGISTRY_BASIS_TYPE.EXEMPTION_2, nameId: 'applicant.exemption.2' },
  { value: VEHICLE_REGISTRY_BASIS_TYPE.EXEMPTION_3, nameId: 'applicant.exemption.3' },
];

export const AUTO_ACCEPT_APPLICANT_STATUS = {
  NO_ACCEPT: 0,
  AUTO_ACCEPT: 1,
  HANDLE_ACCEPT: 2,
};

export const AUTO_ACCEPT_APPLICANT_STATUS_NAMES = {
  [AUTO_ACCEPT_APPLICANT_STATUS.AUTO_ACCEPT]: STATUS_NAMES.SUCCESS,
  [AUTO_ACCEPT_APPLICANT_STATUS.NO_ACCEPT]: STATUS_NAMES.SUSPENDED,
  [AUTO_ACCEPT_APPLICANT_STATUS.HANDLE_ACCEPT]: STATUS_NAMES.CHECKING,
};
